"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL001_Submit_Detail = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const DSTL001_Submit_View_1 = require("./DSTL001_Submit_View");
const DSTL001_Detail_Child_1 = require("./component/DSTL001_Detail_Child");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const react_i18next_1 = require("react-i18next");
const layout_1 = require("../../base/layout");
const server_1 = require("../../../server");
const DSTL001SubmitDetailViewStyled = styled_components_1.default.div `
	${props => (props.$isTablet ? tabletStyles : props.$isMobile ? mobileStyles : desktopStyles)}

	.score-list {
		width: 100%;
		min-width: 0;
	}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 0px;
	align-items: flex-end;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	width: 100%;
	gap: 36px;
	flex: 1;
	overflow: hidden;

	.divider {
		background: var(--color-silver, #f3f4f8);
		align-self: stretch;
		flex-shrink: 0;
		width: 1px;
		position: relative;
	}

	.wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-end;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;
		flex: 1;
		overflow: hidden;
	}

	.submission-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		flex: 1;
	}

	.score-title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h4-font-size, 20px);
		line-height: var(--h4-line-height, 32px);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.score-list {
		flex: 2;
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-end;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 0px;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	width: 100%;
	gap: 36px;
	flex: 1;
	overflow: hidden;

	.divider {
		background: var(--color-silver, #f3f4f8);
		align-self: stretch;
		flex-shrink: 0;
		width: 1px;
		position: relative;
	}

	.wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;
		flex: 1;
		overflow: auto;
	}

	.submission-list {
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		flex: 1;
		min-height: 100%;
	}

	.score-title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h4-font-size, 20px);
		line-height: var(--h4-line-height, 32px);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.score-list {
		flex: 2;
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-end;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 0px;
	width: 100%;
	gap: 36px;
	overflow: auto;
	overflow-x: hidden;
	min-height: 100%;

	.wrap {
		display: flex;
		flex-direction: row;
		gap: 20px;
		width: 100%;
		height: 100%;
		flex: 1;
	}

	.submission-list {
		box-sizing: border-box;
		border-radius: 10px;
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 1px;
		padding: 24px;
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		flex: 1;
		min-height: 100%;
		width: 100%;
	}

	.score-title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h4-font-size, 20px);
		line-height: var(--h4-line-height, 32px);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.score-list {
		flex: 1;
		display: flex;
		flex-direction: column;
	}
`;
// 강사 -> 제출 현황 상세보기
// 학생 리스트 | 제출 현황
exports.DSTL001_Submit_Detail = react_1.default.memo(({ isTest, test_id, isPreview, subjectId, isSurvey = false, }) => {
    const { isTablet, isMobile, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [item, setItem] = react_1.default.useState(null);
    const [member, setMember] = (0, react_1.useState)(undefined);
    const { data, refetch } = (0, server_1.useAssignmentList)({
        id: test_id,
        class_id: classesId,
        survey: isSurvey,
    });
    (0, react_1.useEffect)(() => {
        if (test_id) {
            refetch();
        }
    }, [test_id]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        if (data.found_count > 0) {
            const item = data.items[0];
            setItem(item);
        }
        else {
            setItem(null);
        }
    }, [data]);
    const handlerMember = (newMemeber) => {
        setMember(newMemeber?.id === member?.id ? undefined : newMemeber);
    };
    const renderSubmissionList = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "submission-list", key: 'submitList' },
        react_1.default.createElement(DSTL001_Detail_Child_1.SubmissionStatusTable, { isTest: isTest, test_id: test_id, isDetail: true, isPopUp: true, type: item?.type, handlerUpdateMember: handlerMember, subjectId: subjectId }))), [isTest, test_id, item?.type, handlerMember, subjectId]);
    const renderSubmitView = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "score-list", key: 'submitView' },
        react_1.default.createElement(DSTL001_Submit_View_1.DSTL001_Submit_View, { hideTitle: false, test_id: test_id, member: member, isDetail: true, isPreview: isPreview, subjectId: subjectId, isSurvey: isSurvey }))), [test_id, isPreview, member, subjectId, isSurvey]);
    if (isMobile) {
        return (react_1.default.createElement(DSTL001SubmitDetailViewStyled, { "$isTablet": isTablet, "$isMobile": isMobile },
            react_1.default.createElement(layout_1.MobileTabLayout, { tabList: member
                    ? [
                        {
                            id: 6,
                            component: [renderSubmitView],
                            isDetail: true,
                        },
                    ]
                    : [
                        {
                            id: 7,
                            component: [renderSubmissionList],
                            isDetail: false,
                        },
                    ], showPageButton: false, isSubmit: true, 
                // previousPageList={{
                // 	title: t('assignment.goBack'),
                // 	menuDetail: 'detail',
                // 	setMember: setMember,
                // 	props: { mobilePage: 1 },
                // }}
                test_id: test_id })));
    }
    return (react_1.default.createElement(DSTL001SubmitDetailViewStyled, { "$isTablet": isTablet, "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "wrap" },
            renderSubmissionList,
            isTablet && react_1.default.createElement("div", { className: "divider" }),
            renderSubmitView)));
});
